// QuantaDemoModal.styles.js
export var overlayStyles = {
    backdrop: {
        backdropFilter: "blur(6px)",
        backgroundColor: "rgba(0,0,0,0.75)",
    },
};
export var paperStyles = {
    background: "linear-gradient(145deg, #13131c 0%, #1a1a28 100%)",
    border: "1px solid rgba(212,175,55,0.2)",
    borderRadius: "20px",
    boxShadow: "0 32px 80px rgba(0,0,0,0.8)",
    overflow: "visible",
};
export var topLineStyles = {
    position: "absolute",
    top: 0,
    left: 24,
    right: 24,
    height: "2px",
    background: "linear-gradient(90deg, transparent, #d4af37, #f5c842, #d4af37, transparent)",
    borderRadius: "0 0 2px 2px",
};
export var iconStyles = {
    fontSize: 28,
    color: "#d4af37",
};
export var badgeStyles = {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    background: "rgba(212,175,55,0.1)",
    border: "1px solid rgba(212,175,55,0.3)",
    borderRadius: "100px",
    px: 1.5,
    py: 0.5,
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "1.3px",
    textTransform: "uppercase",
    color: "#d4af37",
    mb: 2,
    width: "fit-content",
};
export var badgeDotStyles = {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: "#f5c842",
    "@keyframes pulse": {
        "0%, 100%": { opacity: 1 },
        "50%": { opacity: 0.3 },
    },
    animation: "pulse 2s infinite",
};
export var titleStyles = {
    fontWeight: 700,
    fontSize: "22px",
    color: "#fff",
    mb: 2,
    lineHeight: 1.3,
};
export var bodyTextStyles = {
    fontSize: "14px",
    lineHeight: 1.75,
    color: "rgba(255,255,255,0.58)",
};
export var dividerStyles = {
    my: 2.5,
    borderColor: "rgba(255,255,255,0.07)",
};
export var infoBoxStyles = {
    background: "rgba(212,175,55,0.05)",
    border: "1px solid rgba(212,175,55,0.14)",
    borderLeft: "3px solid #d4af37",
    borderRadius: "10px",
    p: "14px 16px",
    display: "flex",
    gap: 1.5,
    mb: 3.5,
};
export var infoIconStyles = {
    fontSize: "16px",
    mt: "1px",
    flexShrink: 0,
};
export var infoTextStyles = {
    fontSize: "13px",
    lineHeight: 1.7,
    color: "rgba(255,255,255,0.52)",
};
export var buttonStyles = {
    width: "100%",
    height: 48,
    fontSize: "15px",
    fontWeight: 700,
    borderRadius: "12px",
    background: "linear-gradient(135deg, #c9a227, #f5c842)",
    color: "#0a0a0f",
    border: "none",
    boxShadow: "0 4px 20px rgba(212,175,55,0.35)",
    "&:hover": {
        background: "linear-gradient(135deg, #d4af37, #fad55c)",
        boxShadow: "0 8px 30px rgba(212,175,55,0.5)",
        borderColor: "transparent",
    },
};
export var iconWrapStyles = {
    width: 62,
    height: 62,
    background: "rgba(212,175,55,0.1)",
    border: "1.5px solid rgba(212,175,55,0.3)",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: 3,
};
